import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  deviceData: null,
  sharedDeviceData: null,
  sharedDevicePromise: null,
  numOfDevices: 0,
  promise: null,
  shareDevice: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
